const clientCompanySelection = {
  welcomeTitle: "مرحبًا بعودتك، {name} 👋",
  welcomeSubtitle:
    "لديك {count} شراكات فعاليات نشطة تتطلب انتباهك اليوم.",
  sectionTitle: "شراكات الفعاليات الخاصة بك",
  activeCount: "نشط: {count}",
  partnerCompany: "شركة شريكة",
  selectCompanyAria: "فتح مساحة عمل {company}",
  switchCompanyTriggerAria: "تبديل مساحة عمل الشركة",
  switchCompanyMenuAria: "مساحات عمل الشركات المتاحة",
};

export default clientCompanySelection;
